export const SUPPORTED_EXTENSIONS: string[] = ['doc', 'docx', 'xls', 'xlsx', 'pdf'];

export const EXTENSION_ICON_MAP: Record<string, string> = {
  pdf: 'sc-red icon-document-pdf icon--s4',
  doc: 'sc-navy icon-document-word icon--s4',
  docx: 'sc-navy icon-document-word icon--s4',
  xls: 'int-green icon-document-excel icon--s4',
  xlsx: 'int-green icon-document-excel icon--s4',
};
